import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class ProjectClientCheckModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showClientCheckModal = this.showClientCheckModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal        : false,
      targets      : [],
      send_targets : [],
    };
  }
  // -------------------------------------------------------
  
  showClientCheckModal(targets) {
    this.setState({ modal: true, targets: targets, send_targets: targets });
  }
  // -------------------------------------------------------
  
  closeClientCheckModal() {
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  submit() {
    Utils.request.bind(this)('/api/project/workflow/bulk_client_check', { project_id: this.props.data.project.id, targets: this.state.send_targets, recommend_text: this.recommend_text.value },
      function(res){
        
        alert('まとめてチェックを依頼しました！');
        this.props.data.event.updateData('workflow', res.body.workflow);
        this.setState({ modal: false });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  toggleTargets(insta_user_id) {
    let send_targets = this.state.send_targets;
    if( send_targets.indexOf(insta_user_id) == -1 ){
      send_targets.push(insta_user_id);
    } else {
      send_targets = send_targets.filter((id) => { if( id != insta_user_id ) return id; });
    }
    this.setState({ send_targets: send_targets });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    
    let member_count = 0;
    let followers_count = 0;
    this.state.send_targets.map((id) => {
      try {
        let inf = base.workflow.influencers[id];
        if( inf == undefined ) return;
        
        member_count += 1;
        followers_count += inf.followers;
      } catch(e) {}
    });
    
    return (
      <div className="project-client-check-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {615}
          height    = {535}
          close_ev  = {this.closeClientCheckModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2 className="check-title">まとめてクライアントにチェックの依頼をします。よろしいですか？</h2>
              
              <h5>対象者のインフルエンサーを選択してください</h5>
              <ul>
                { this.state.targets.map((id, key) => {
                  let account = {};
                  try { account = base.workflow.influencers[id]; } catch(e) {}
                  if( Object.keys(account).length == 0 ) return null;
                  
                  let flg = (this.state.send_targets.indexOf(id) == -1) ? 'off' : 'on';
                  
                  return (
                    <OverlayTrigger key={key} placement="left" delayShow={50} overlay={<Tooltip>@{account.insta_id}</Tooltip>}>
                      <li className={flg} onClick={this.toggleTargets.bind(this, id)}>
                        <img src={account.thumbnail} />
                      </li>
                    </OverlayTrigger>
                  );
                })}
              </ul>
              
              <div className="score-box">
                <div className="score-item">
                  <h5>クライアント確認人数</h5>
                  <p className="member-count">{Utils.viewInt(member_count)}<span>人</span></p>
                </div>
                
                <div className="score-item">
                  <h5>フォロワー数の合計</h5>
                  <p className="followers-count">{Utils.viewInt(followers_count)}<span>人</span></p>
                </div>
              </div>
              
              <h4>クライアントへのメッセージ</h4>
              <textarea className="text" ref={(input) => { this.recommend_text = input }} placeholder={'おすすめ理由や推薦コメントなど記入してください'} />
              
              <div className="yes-no">
                { (this.state.send_targets.length == 0)
                  ? <p className="button yes off">送信</p>
                  : <p className="button yes" onClick={this.submit.bind(this)}>送信</p>
                }
                <p className="button no" onClick={this.closeClientCheckModal.bind(this)}>キャンセル</p>
              </div>
            </div>
          }
        />
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectClientCheckModal;